import { Injectable } from "@angular/core";
import { Topics } from "@common/interfaces/topics";
import { IID_OL_OLOREQUEST } from "@common/interfaces/interfaceData";
import { ID } from '@common/interfaces/id';
import { EntityState, EntityStore, StoreConfig } from "@datorama/akita";

export interface IIDolOloRequestState extends EntityState<IID_OL_OLOREQUEST, ID> { }

@Injectable({
  providedIn: 'root'
})
@StoreConfig({ name: Topics.IID_OL_OLO_REQUEST })
export class IIDolOloRequestStore extends EntityStore<IIDolOloRequestState> {
  constructor() {
    super([]);
  }
}
